import defineMessages from "../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    editScore: {
        id: "tasks.melodyTable.editScore",
    },
    stopEdit: {
        id: "tasks.stopEdit",
    },
    firstKnown: {
        id: "tasks.melodyTable.firstKnown",
    },
    uploadAudio: {
        id: "general.uploadAudio",
    },
});

export default messages;
